import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  container:{
    height: '100%',
    display: 'flex',
    overflow: 'auto',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  pagination: {
    position: 'static',
    width: '100%',
    bottom: '0',
  },
  stepDot: {
    width: '8px',
    height: '8px',
    display: 'inline-block',
    backgroundColor: theme.colors.lightGray.dark,
    margin: '8px',
    borderRadius: '50%',
    transition: 'all .2s ease',
  },
  activeDot: {
    backgroundColor: theme.colors.text.normal,
  },
}));

export default useStyle;
